var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-12 mb-1" }, [
        _vm._v(
          " Para asegurarnos que una persona es quien dice ser, Escritorio Digital provee para algunos de sus servicios un 2FA, lo que permite validar, además de la contraseña del usuario, una segunda contraseña del tipo OTP (One-Time Password, en español: Contraseña de un solo uso), la cual es sólo visible a través de un dispositivo móvil, como tu smartphone, por unos cuantos segundos. "
        )
      ]),
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _c("div", { staticClass: "col-12 mb-1" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-lg-4 col-md-6 text-center mt-3" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "numeric|required|min:4|max:6",
                    expression: "'numeric|required|min:4|max:6'"
                  }
                ],
                staticClass: "w-full",
                attrs: {
                  name: "otp",
                  "icon-pack": "material-icons",
                  icon: "account_circle",
                  "icon-no-border": "",
                  label: "Código OTP de Google Authenticator",
                  value: _vm.form.otp
                },
                on: {
                  input: function($event) {
                    return _vm.actualiza("otp", $event)
                  }
                }
              }),
              _c("span", { staticClass: "text-danger text-sm" }, [
                _vm._v(_vm._s(_vm.errors.first("otp")))
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 col-md-3 text-center mt-3" },
            [
              _c(
                "vx-tooltip",
                {
                  attrs: {
                    text: "Al hacer click verificara el OPT",
                    position: "top"
                  }
                },
                [
                  _c(
                    "vs-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.checking,
                          expression: "!form.checking"
                        }
                      ],
                      staticClass: "mt-5",
                      attrs: { type: "border" },
                      on: { click: _vm.sendToVerifyOTP }
                    },
                    [_vm._v(" Verificar ")]
                  )
                ],
                1
              ),
              _c("b-spinner", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.checking,
                    expression: "form.checking"
                  }
                ],
                attrs: { small: "", variant: "primary" }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4 col-md-3 text-center mt-3" },
            [
              _c(
                "vx-tooltip",
                {
                  attrs: { text: "Solicitar nuevo codigo OTP", position: "top" }
                },
                [
                  _c(
                    "vs-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.form.checking,
                          expression: "!form.checking"
                        }
                      ],
                      staticClass: "mt-5",
                      attrs: { type: "border" },
                      on: { click: _vm.sendNew }
                    },
                    [_vm._v(" Enviar mi Código QR ")]
                  )
                ],
                1
              ),
              _c("b-spinner", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.checking,
                    expression: "form.checking"
                  }
                ],
                attrs: { small: "", variant: "primary" }
              })
            ],
            1
          )
        ])
      ]),
      _c("b-toast", { attrs: { id: "solicitar-ok" } }, [
        _c("span", [_vm._v("Se envio nuevo codigo OTP")])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-1" }, [
      _c("b", [_vm._v("Como configurar 2FA?")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-1" }, [
      _c("ul", { staticStyle: { "list-style-type": "none" } }, [
        _c("li", [
          _vm._v("1.- Descarga en tu dispositivo móvil la aplicación "),
          _c("b", [_vm._v("Google Authenticator")]),
          _vm._v(" (disponible en App Store de IOS y Play Store de Android). ")
        ]),
        _c("li", [
          _vm._v("2.- Presiona el botón de mas abajo llamado "),
          _c("b", [_vm._v('"Enviar mi código QR"')]),
          _vm._v(".")
        ]),
        _c("li", [
          _vm._v("3.- Abre la aplicación "),
          _c("b", [_vm._v("Google Authenticator")]),
          _vm._v(
            " y sigue las instrucciones para escanear un nuevo codigo QR. "
          )
        ]),
        _c("li", [
          _vm._v(
            "4.- Escanea el código QR que fue enviado a tu correo electrónico."
          )
        ]),
        _c("li", [
          _vm._v(
            "5.- Para verificar que todo ha quedado correctamente configurado, ingresa mas abajo el código de 6 dígitos para validar. "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-1" }, [
      _c("b", [_vm._v("Importante: ")]),
      _vm._v(" Si ya habias configurado con anterioridad 2FA de "),
      _c("b", [_vm._v(" Escritorio Digital ")]),
      _vm._v(" con "),
      _c("b", [_vm._v(" Google Authenticator ")]),
      _vm._v(
        " y vuelves a enviar un código QR a tu correo electrónico, la configuración anterior dejará de ser válida. Puedes hacer esto tambien, si crees que ha sido comprometida la seguridad del código QR o cambiaste de dispositivo móvil. "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }